// import React from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { Link } from 'react-router-dom';

// const templates = [
//     { name: 'eMedha Chatbot Services_team (en)', preview: 'Say Hello! to eMedha Chatbot Services 👋', status: 'APPROVED', created: '10 Apr, 2024', modified: '10 Apr, 2024' },
//     { name: 'test_character_limit_templat...', preview: 'Contrary to popular belief, L...', status: 'APPROVED', created: '29 Mar, 2024', modified: '29 Mar, 2024' },
//     { name: 'text_template_011_new_011...', preview: 'Hello {{1}}, Thank you for sh...', status: 'APPROVED', created: '12 Feb, 2024', modified: '12 Feb, 2024' },
//     { name: 'lto_02_copy_new', preview: 'Honest feedbacks from som...', status: 'APPROVED', created: '12 Feb, 2024', modified: '12 Feb, 2024' },
//     { name: 'update_lto02_copy', preview: 'Check here!!!', status: 'APPROVED', created: '12 Feb, 2024', modified: '12 Feb, 2024' }
// ];

// const MessageTemplates = () => {
//     return (
//         <div className="container mt-4">
//             <h3>Message Templates</h3>
//             <div className="d-flex mb-3 gap-2">
//              <Link to='/add-templates'>  <button className="btn btn-success">Add New</button></Link> 
//                 <button className="btn btn-outline-primary">Fetch Templates</button>
//                 <button className="btn btn-outline-secondary">Refresh Statuses</button>
//                 <input type="text" className="form-control w-25 ms-auto" placeholder="Search..." />
//             </div>
//             <table className="table table-striped table-hover">
//                 <thead>
//                     <tr>
//                         <th>TEMPLATE NAME</th>
//                         <th>PREVIEW</th>
//                         <th>STATUS</th>
//                         <th>CREATED</th>
//                         <th>LAST MODIFIED</th>
//                         <th>ACTIONS</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {templates.map((template, index) => (
//                         <tr key={index}>
//                             <td>{template.name}</td>
//                             <td>{template.preview}</td>
//                             <td>
//                                 <span className="badge bg-success">{template.status}</span>
//                             </td>
//                             <td>{template.created}</td>
//                             <td>{template.modified}</td>
//                             <td>
//                                 <i className="fas fa-chart-line me-2"></i>
//                                 <i className="fas fa-edit me-2"></i>
//                                 <i className="fas fa-trash-alt"></i>
//                             </td>
//                         </tr>
//                     ))}
//                 </tbody>
//             </table>
//             <div className="d-flex justify-content-between align-items-center">
//                 <span>Showing 1 to 5 of 89 entries</span>
//                 <nav>
//                     <ul className="pagination mb-0">
//                         <li className="page-item"><a className="page-link" href="#">Previous</a></li>
//                         <li className="page-item active"><a className="page-link" href="#">1</a></li>
//                         <li className="page-item"><a className="page-link" href="#">2</a></li>
//                         <li className="page-item"><a className="page-link" href="#">3</a></li>
//                         <li className="page-item"><a className="page-link" href="#">Next</a></li>
//                     </ul>
//                 </nav>
//             </div>
//         </div>
//     );
// };

// export default MessageTemplates;




//-------------------- Rahul Verma open-----------------//

// import React, { useState, useEffect } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { useNavigate } from 'react-router-dom';
// import { FaEye } from 'react-icons/fa';

// const MessageTemplates = () => {
//     const [templates, setTemplates] = useState([]);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [templatesPerPage] = useState(10);
//     const [searchQuery, setSearchQuery] = useState('');
//     const navigate = useNavigate();

//     const fetchTemplates = async () => {
//         try {
//             const response = await fetch('https://emedha.com/echatbot/enotifier/getTemplateStatus.php?limit=10');
//             const data = await response.json();
//             if (data && data.data) {
//                 setTemplates(data.data);
//             }
//         } catch (error) {
//             console.error("Error fetching templates:", error);
//         }
//     };

//     useEffect(() => {
//         fetchTemplates();
//     }, []);

//     const handleRefreshStatuses = () => {
//         window.location.reload();
//     };

//     const filteredTemplates = templates.filter(template =>
//         template.name.toLowerCase().includes(searchQuery.toLowerCase())
//     );

//     const indexOfLastTemplate = currentPage * templatesPerPage;
//     const indexOfFirstTemplate = indexOfLastTemplate - templatesPerPage;
//     const currentTemplates = filteredTemplates.slice(indexOfFirstTemplate, indexOfLastTemplate);

//     const paginate = (pageNumber) => setCurrentPage(pageNumber);

//     const handleViewTemplateDetails = async (templateName) => {
//         try {
//             const response = await fetch(`https://emedha.com/echatbot/enotifier/getTemplateInfo.php?name=${templateName}`);
//             const data = await response.json();
//             if (data && data.data && data.data.length > 0) {
//                 const templateDetails = data.data[0];
//                 navigate('/message-temp-view', { state: { templateDetails } });
//             } else {
//                 console.log("No details found for this template");
//             }
//         } catch (error) {
//             console.error("Error fetching template details:", error);
//         }
//     };

//     return (
//         <div className="container mt-4">
//             <h3>Message Templates</h3>
//             <div className="d-flex mb-3 gap-2">
//                 <button className="btn btn-outline-primary btn-sm">Fetch Templates</button>
//                 <button className="btn btn-outline-secondary btn-sm" onClick={handleRefreshStatuses} >Refresh Statuses</button>
//                 <input type="text" className="form-control w-25 ms-auto" placeholder="Search..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
//             </div>
//             <table className="table table-striped table-hover table-bordered">
//                 <thead className="table table-dark">
//                     <tr>
//                         <th>TEMPLATE NAME</th>
//                         <th>STATUS</th>
//                         <th>ACTIONS</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {currentTemplates.map((template, index) => (
//                         <tr key={index}>
//                             <td>{template.name}</td>
//                             <td><span className={`badge ${template.status === 'REJECTED' ? 'bg-danger' : 'bg-success'}`} style={template.status === 'REJECTED' ? { color: 'white' } : {}}>{template.status}</span></td>
//                             <td><FaEye style={{ cursor: "pointer" }} onClick={() => handleViewTemplateDetails(template.name)} /></td>
//                         </tr>
//                     ))}
//                 </tbody>
//             </table>

//             <div className="d-flex justify-content-between align-items-center">
//                 <span>Showing {indexOfFirstTemplate + 1} to {Math.min(indexOfLastTemplate, filteredTemplates.length)} of {filteredTemplates.length} entries</span>
//                 <nav>
//                     <ul className="pagination mb-0">
//                         <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
//                             <button className="page-link btn-sm" onClick={() => paginate(currentPage - 1)}>Previous</button>
//                         </li>
//                         {[...Array(Math.ceil(filteredTemplates.length / templatesPerPage)).keys()].map((pageNumber) => (
//                             <li key={pageNumber + 1} className={`page-item ${currentPage === pageNumber + 1 ? 'active' : ''}`}>
//                                 <button className="page-link btn-sm" onClick={() => paginate(pageNumber + 1)}>{pageNumber + 1}</button>
//                             </li>
//                         ))}
//                         <li className={`page-item ${currentPage === Math.ceil(filteredTemplates.length / templatesPerPage) ? 'disabled' : ''}`}>
//                             <button className="page-link btn-sm" onClick={() => paginate(currentPage + 1)}>Next</button>
//                         </li>
//                     </ul>
//                 </nav>
//             </div>
//         </div>
//     );
// };

// export default MessageTemplates;

//-------------------- Rahul Verma close-----------------//



import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaEye } from 'react-icons/fa';

const MessageTemplates = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [templatesPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState('');

    // ✅ Mock template data
    const mockTemplates = [
        // { name: 'Welcome_Message', status: 'APPROVED' },
        // { name: 'Order_Confirmation', status: 'REJECTED' },
        // { name: 'Feedback_Request', status: 'APPROVED' },
        // { name: 'Subscription_Alert', status: 'REJECTED' },
        // { name: 'Discount_Offer', status: 'APPROVED' },
        // { name: 'Follow_Up', status: 'APPROVED' },
        // { name: 'Holiday_Greetings', status: 'REJECTED' },
        // { name: 'Event_Invite', status: 'APPROVED' },
        // { name: 'Survey_Request', status: 'REJECTED' },
        // { name: 'Account_Notice', status: 'APPROVED' },
        // Add more mock data if needed
    ];

    const filteredTemplates = mockTemplates.filter(template =>
        template.name.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const indexOfLastTemplate = currentPage * templatesPerPage;
    const indexOfFirstTemplate = indexOfLastTemplate - templatesPerPage;
    const currentTemplates = filteredTemplates.slice(indexOfFirstTemplate, indexOfLastTemplate);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const handleViewTemplateDetails = (templateName) => {
        alert(`View details for: ${templateName}`);
    };

    return (
        <div className="container mt-4">
            <h3>Message Templates</h3>
            <div className="d-flex mb-3 gap-2">
                <button className="btn btn-outline-primary btn-sm" onClick={() => alert('Fetch Templates Clicked')}>Fetch Templates</button>
                <button className="btn btn-outline-secondary btn-sm" onClick={() => window.location.reload()}>Refresh Statuses</button>
                <input
                    type="text"
                    className="form-control w-25 ms-auto"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                />
            </div>

            <table className="table table-striped table-hover table-bordered">
                <thead className="table-dark">
                    <tr>
                        <th>TEMPLATE NAME</th>
                        <th>STATUS</th>
                        <th>ACTIONS</th>
                    </tr>
                </thead>
                <tbody>
                    {currentTemplates.map((template, index) => (
                        <tr key={index}>
                            <td>{template.name}</td>
                            <td>
                                <span className={`badge ${template.status === 'REJECTED' ? 'bg-danger' : 'bg-success'}`}>
                                    {template.status}
                                </span>
                            </td>
                            <td>
                                <FaEye style={{ cursor: "pointer" }} onClick={() => handleViewTemplateDetails(template.name)} />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className="d-flex justify-content-between align-items-center">
                <span>
                    Showing {indexOfFirstTemplate + 1} to {Math.min(indexOfLastTemplate, filteredTemplates.length)} of {filteredTemplates.length} entries
                </span>
                <nav>
                    <ul className="pagination mb-0">
                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                            <button className="page-link btn-sm" onClick={() => paginate(currentPage - 1)}>Previous</button>
                        </li>
                        {[...Array(Math.ceil(filteredTemplates.length / templatesPerPage)).keys()].map((pageNumber) => (
                            <li key={pageNumber + 1} className={`page-item ${currentPage === pageNumber + 1 ? 'active' : ''}`}>
                                <button className="page-link btn-sm" onClick={() => paginate(pageNumber + 1)}>{pageNumber + 1}</button>
                            </li>
                        ))}
                        <li className={`page-item ${currentPage === Math.ceil(filteredTemplates.length / templatesPerPage) ? 'disabled' : ''}`}>
                            <button className="page-link btn-sm" onClick={() => paginate(currentPage + 1)}>Next</button>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    );
};

export default MessageTemplates;
